import React from 'react';

const MortgageRepaymentAssumptionContent = () => {
  return (
    <React.Fragment>
      <p>
        This calculator helps you work out the potential amount that you can borrow.
      </p>
      <p>
        The output or result of this calculator:
      </p>
      <ul>
        <li>
          is prepared without taking into consideration your personal financial circumstances. Before you act on the output of the calculator, please consider if it’s right for you. We recommend that you consult our Loan Consultants or your professional adviser before making any decision based on this information;
        </li>
        <li>
          does not represent either a quote or pre-qualification for any of our loan products; and
        </li>
        <li>
          the interest rates used in the calculator are current as at the date of the calculation and are subject to change.
        </li>
      </ul>
      <p>
        The calculation is not an offer of credit to you but simply an estimate only of what you may be able to save or borrow based on the information that you have inputted in the calculator. It is a general calculation only that does not include applicable fees payable. The amount that you may be eligible to save or borrow may be different when you complete a full application, and we capture all details relevant to our eligible lending criteria. The information is valid as at the date of this calculation which is subject to change without notice.
      </p>
      <p>
        Terms, conditions and eligibility criteria apply to all of our loan products and features. Fees, charges and disbursements are payable. Final approval is subject to our full credit assessment. 
      </p>
    </React.Fragment>
  )
}

export default MortgageRepaymentAssumptionContent;
